export const EXPERIMENT_VERSION_5 = 'version5';
export const EXPERIMENT_LARGE_CTA = 'large-cta';
export const LARGE_CTA_DISMISSED_CACHE_KEY = 'large-cta-cache-dismissed';

export default {};
